// extracted by mini-css-extract-plugin
export default {"news_live":"index_news_live_mKz7K clearfix","stock_news":"index_stock_news_7Qcrh"};